import loadable from "@loadable/component"
import { useState, useCallback } from "react"

import Modal, { closeModal } from "components/modal"
import { retry } from "helpers/application"

const Login = loadable(() => retry(() => import("./login")))
const Register = loadable(() => retry(() => import("./register")))

const Authenticate = () => {
  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => {
    setShowContent(true)
  })
  const [modalContent, setModalContent] = useState("#authenticate")

  return (
    <Modal
      afterShow={afterShow}
      contentClassName="p-0 tablet:p-0"
      contentIndex={modalContent === "#signup" ? 0 : 1}
      headerVariant="float"
      onBack={() => setModalContent("#authenticate")}
      onClose={() => closeModal()}
      setModalContent={setModalContent}
      show={["#authenticate", "#signup"]}
    >
      {showContent && (
        <>
          {modalContent === "#signup" && (
            <Register setModalContent={setModalContent} />
          )}
          {modalContent === "#authenticate" && (
            <Login setModalContent={setModalContent} />
          )}
        </>
      )}
    </Modal>
  )
}

export default Authenticate
